import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    let hydratedSrcFromData = false;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) {
        source.setAttribute('src', videoSource);
        hydratedSrcFromData = true;
      }
    }

    // Only reload when src was applied from data attributes; inline src (e.g. hero) is already loading.
    if (hydratedSrcFromData) {
      videoElement.load();
    }
    // HTML autoplay is not always reliable; muted + programmatic play satisfies most policies.
    void videoElement.play().catch(() => {});
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
